import { z } from 'zod'
import { readonly } from '@thinknimble/tn-models'
import { baseModelShape } from '../baseModel'

export const canvassingOrgShape = {
  id: z.string().uuid(),
  name: z.string(),
  enableMandatoryLocation: z.boolean().optional(),
}

export const homeOfficeShape = {
  ...baseModelShape,
  id: z.string().uuid(),
  name: z.string(),
}

export const groupShape = {
  ...baseModelShape,
  name: z.string(),
}

export const userShape = {
  ...baseModelShape,
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  fullName: z.string(),
  token: readonly(z.string().nullable()),
  groups: z.array(z.object(groupShape)).optional(),
  campaigns: z.array(z.string()).optional(),
  canvassingOrg: z.object(canvassingOrgShape).nullable().optional(),
  canvassingOrgs: z.array(z.object(canvassingOrgShape)).optional(),
  isActive: z.boolean(),
  homeOffice: z.object(homeOfficeShape).nullable().optional(),
  employeeId: z.string(),
  profilePicture: z.string().url().nullable().optional(),
  mfaActivated: z.boolean(),
  profileType: z.string().nullable().optional(),
}

export const userCreateShape = {
  email: userShape.email,
  firstName: userShape.firstName,
  lastName: userShape.lastName,
  password: z.string(),
}

export const inviteFundraiserShape = {
  email: userShape.email,
  firstName: userShape.firstName,
  lastName: userShape.lastName,
  homeOffice: z.string(),
  employeeId: userShape.employeeId,
  profilePicture: userShape.profilePicture,
  canvassingOrg: z.string().uuid().optional(),
}

export const forgotPasswordShape = {
  email: z.string().email(),
}

export const loginShape = {
  email: z.string().email(),
  password: z.string(),
  phase: z.string().optional(),
  otp: z.string().optional(),
  userId: z.string().uuid().optional(),
}

export const updateStatus = {
  id: z.string().uuid(),
  isActive: z.boolean().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().optional(),
  homeOffice: z.string().optional(),
  employeeId: z.string().optional(),
  profilePicture: z.union([z.string(), z.null()]).optional(),
  password: z.string().optional(),
  profileType: z.string().optional(),
}

export const userFiltersShape = {
  ordering: z.string().optional(),
  fundraiser: z.string(),
  homeOffice: z.string(),
  userStatus: z.string(),
  canvassingOrg: z.string().optional(),
}

export const userRetriveShape = {
  id: z.string(),
}
